module.exports = __webpack_public_path__ + "img/appIcon-menu--Invoicing--active.d3e8d012.svg";